import { useMemo } from 'react';
import { useCacheConfig } from 'legacyfrontend/contexts/CacheConfigContext';
import type { SearcherItem } from 'shared/searchers';
import { AccionAplicacion, toLinkSearchers } from './searcherLinks';

/** Url-only searcher tabs for the current tenant. */
export function useSearcherLinks(): SearcherItem[] {
  const { accionesAplicacion } = useCacheConfig();

  return useMemo(
    () => toLinkSearchers(accionesAplicacion as AccionAplicacion[] | undefined),
    [accionesAplicacion],
  );
}
